/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
 
function FeatureStoryInformation() {
  return ( 
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Elections Nova Scotia Annual Report 2024-2025"
              description={
                <>
                  <br/>
                  Elections Nova Scotia has released its annual report for the period of April 1, 2024 – March 31, 2025, in accordance with Section 5 of the Elections Act.
                  <br />
                  <br />
                  The 2024-2025 fiscal year activity focused on executing the 42nd Provincial General Election. Over the twelve-month period, ENS worked steadily on election readiness projects and accelerated our planning when an early election call was anticipated. The annual report shows our progress towards our strategic goals and includes independently audited financial statements. 
                  <br />
                  <br />
                  <a href="/files/AnnualAndOtherReports/ENS Annual Report 2025_ENG_FINAL_web copy.pdf"><u>Click here to view the Annual Report in English</u></a>
                  <br/>
                  <br/>
                  <a href="/files/AnnualAndOtherReports/ENS Annual Report 2025_FRE_FINAL.pdf"><u>Click here to view the Annual Report in French</u></a>
                  <br />
                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default FeatureStoryInformation;


